import React, { Component } from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import JDate from "jalali-date"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import * as constants from "../constants"
import Slider from "@material-ui/core/Slider"


const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
      },
      container: {
            maxHeight: 400,
      },
})

const AirbnbSlider = withStyles({
      root: {
            color: "#3a8589",
            height: 3,
            padding: "13px 0",
      },
      thumb: {
            height: 27,
            width: 27,
            backgroundColor: "#fff",
            border: "1px solid currentColor",
            marginTop: -12,
            marginLeft: -13,
            boxShadow: "#ebebeb 0px 2px 2px",
            "&:focus, &:hover, &$active": {
                  boxShadow: "#ccc 0px 2px 3px 1px",
            },
            "& .bar": {
                  // display: inline-block !important;
                  height: 9,
                  width: 1,
                  backgroundColor: "currentColor",
                  marginLeft: 1,
                  marginRight: 1,
            },
      },
      active: {},
      valueLabel: {
            left: "calc(-50% + 4px)",
      },
      track: {
            height: 3,
      },
      rail: {
            color: "#d8d8d8",
            opacity: 1,
            height: 3,
      },
})(Slider)

function AirbnbThumbComponent(props: any) {
      return (
            <span {...props}>
                  <span className="bar" />
                  <span className="bar" />
                  <span className="bar" />
            </span>
      )
}

class GetLocation extends Component {
      cookies = new Cookies()

      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  statusinfos: [],
                  statusinfosfilter: [],
                  minValue: 0,
                  maxValue: 0,
                  maxBar: 0,
                  minBar: 0,
                  maxSlide: 1000000,
                  minSlide: 0,
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.getEmployeeStateInfo()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")
                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getEmployeeStateInfo() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              console.log(arr)
                              self.setState(
                                    {
                                          statusinfos: arr.data,
                                          statusinfosfilter: arr.data,
                                          maxValue: arr.data[0].location_time,
                                          minValue: arr.data[arr.data.length - 1].location_time,
                                          maxBar: arr.data[0].location_time,
                                          minBar: arr.data[arr.data.length - 1].location_time,
                                    },
                                    () => {
                                          // self.changeValueSlider(null,[0,1000000])
                                    }
                              )
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_location")
            fd.append("employee_token_str", this.cookies.get("employee_token_str"))
            xhttp.open("POST", `${constants.BASE_URL}/location`)
            xhttp.send(fd)
      }

      changeValueSlider = (event, number) => {
            const { statusinfos, maxBar, minBar } = this.state
            var temparray = [],
                  i
            var max = parseInt(minBar) + parseInt(((maxBar - minBar) * number[0]) / 1000000)
            var min = parseInt(minBar) + parseInt(((maxBar - minBar) * number[1]) / 1000000)

            for (i = 0; i < statusinfos.length; i++) {
                  if (parseInt(statusinfos[i].location_time) >= min && parseInt(statusinfos[i].location_time) <= max) {
                        temparray.push(statusinfos[i])
                  }
            }
            this.setState({
                  maxValue: max,
                  minValue: min,
                  statusinfosfilter: temparray,
                  maxSlide: number[0],
                  minSlide: number[1],
            })
      }

      render() {
            const { classes } = this.props
            const { maxSlide, minSlide, minValue, maxValue, okstatus, errstr, redirect, statusinfosfilter } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  var dateMinStr = ""
                  var dateMaxStr = ""
                  var date
                  var jdate1
                  if (minValue !== 0) {
                        date = new Date(parseInt(minValue * 1000))
                        jdate1 = new JDate(date)
                        dateMinStr = jdate1.format("DD MMMM YYYY") + "ساعت " + date.getHours() + ":" + date.getMinutes()
                  }
                  if (maxValue !== 0) {
                        date = new Date(parseInt(maxValue * 1000))
                        jdate1 = new JDate(date)
                        dateMaxStr = jdate1.format("DD MMMM YYYY") + "ساعت " + date.getHours() + ":" + date.getMinutes()
                  }
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}>
                                                                  <Typography variant="h6">بازه زمانی</Typography>
                                                                  <AirbnbSlider
                                                                        ThumbComponent={AirbnbThumbComponent}
                                                                        getAriaLabel={(index) => (index === 0 ? "Minimum price" : "Maximum price")}
                                                                        defaultValue={[0, 1000000]}
                                                                        onChange={this.changeValueSlider}
                                                                        min={0}
                                                                        max={1000000}
                                                                        value={[minSlide, maxSlide]}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography align="center" variant="h7">
                                                                              {dateMaxStr}
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography align="center" variant="h7">
                                                                              {dateMinStr}
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>

                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(GetLocation)
